import BaseRequest from './BaseRequest';

const schema = 'prize';

class PrizeRequest extends BaseRequest {
  fetchPrize() {
    const url = `${schema}/`;
    return this.get(url);
  }

  createPrize(data) {
    const url = `${schema}/`;
    return this.post(url, data);
  }

  updatePrize(data) {
    const url = `${schema}/${data.id}`;
    return this.put(url, data);
  }
}

export default PrizeRequest;
